export const ROUTES = {
  LOGIN: "/login",
  RESET_PASSWORD: "/reset-password",
  NEW_PASSWORD: "/reset-password/new",
  CAMPAIGN_OVERVIEW: "/",
  ADMIN_USERS: "/admin/users",
} as const;
